(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["dp-portrait-film"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('dp-portrait-player')) customElements.define('dp-portrait-player', class extends HTMLElement {
  connectedCallback() {
    if (this.ready) return;
    this.ready = true;
    this.button = this.querySelector('button');
    this.onStart = () => this.start();
    this.onOther = event => { if (event.detail !== this) this.stop(); };
    this.button.addEventListener('click', this.onStart);
    document.addEventListener('dp:media', this.onOther);
  }
  start() {
    if (!this.video) {
      this.append(this.querySelector('template').content.cloneNode(true));
      this.video = this.querySelector('video');
      this.video.tabIndex = 0;
      this.video.poster = this.querySelector('.dp-portrait-poster')?.currentSrc || '';
      this.video.addEventListener('play', () => {
        document.dispatchEvent(new CustomEvent('dp:media', {detail: this}));
        this.querySelector('.dp-portrait-error').hidden = true;
        this.video.hidden = false;
        this.button.hidden = true;
      });
      this.video.addEventListener('ended', () => this.stop());
      this.video.addEventListener('error', () => { this.querySelector('.dp-portrait-error').hidden = false; this.button.hidden = false; });
    }
    this.video.hidden = false;
    this.video.play().then(() => { this.button.hidden = true; this.video.focus(); }).catch(() => { this.button.hidden = false; });
  }
  stop() { if (this.video) { this.video.pause(); this.video.currentTime = 0; this.video.hidden = true; } if (this.button) this.button.hidden = false; }
  disconnectedCallback() { this.stop(); this.button?.removeEventListener('click', this.onStart); document.removeEventListener('dp:media', this.onOther); this.ready = false; }
});
  } catch(e) { console.error(e); }
})();

})();
